import { Col, Row } from "reactstrap";
import { ContentBlock } from "../Content/ContentBlock";
import { ContentBody } from "../Content/ContentBody";

interface Props {
    children: React.ReactNode,
    title?: string,
    description?: string
}

export const FormContainer = (props: Props) => {
    return (
        <ContentBlock className="formContainerCotentBlock">
            <ContentBody>
                <div className="white paddingBottom">
                {props.title || props.description ? (
                        <div className="sectionPadding contentBlock formContainer">
                            {props.title &&
                                <h2 className="css_heading bold" dangerouslySetInnerHTML={{ __html: props.title }} />
                            }
                            {props.description &&
                                <div dangerouslySetInnerHTML={{ __html: props.description }} />
                            }
                </div>
                ) : ('')}
                <Row className="contentBlock formContainer">
                    {props.children}
                    </Row>
                </div>
            </ContentBody>
        </ContentBlock>
    );
};
